import Service from "@/code/service";
import { setService, initialLoadDone } from "@/views/service/main";
import { ServiceSpec } from "@/views/service/service-spec";
import { reactive, ref } from "vue";

export let serviceIdList: string[] = [];
export let serviceList: { [key: string]: Service } = reactive({});
export let serviceSpecList: { [key: string]: ServiceSpec } = reactive({});
export let fetchingServiceList = ref(true);
export let allServicesLoaded = ref(false);
export let serviceRaw: any = {};
export let notExist = ref(false);
export let pendServiceFetchError = ref(false); // pend- 로드 실패 감지용
// let pendingLoads = 0; // 현재 로딩 중인 Service.load 호출 수

export let loadServiceList = async () => {
    const router = (await import("@/router")).default;
    let firstLoadServiceId = "";
    notExist.value = false;

    try {
        const resolved = router.resolve(
            window.location.pathname + window.location.search,
        );
        firstLoadServiceId = (resolved.params?.service as string) || "";
    } catch (e) {
        const currentRoute = router.currentRoute?.value;
        firstLoadServiceId = (currentRoute?.params?.service as string) || "";
    }

    // serviceIdList 안에 없는 ID면 무시
    if (
        firstLoadServiceId.length > 0 &&
        !firstLoadServiceId.includes("pend-") &&
        !serviceIdList.includes(firstLoadServiceId)
    ) {
        firstLoadServiceId = "";
        notExist.value = true;
    }

    const rest = serviceIdList.filter((id) => id !== firstLoadServiceId);
    // fetchingServiceList.value = true;
    allServicesLoaded.value = false;

    // 1. 먼저 특정 서비스 로드
    if (firstLoadServiceId && !serviceList[firstLoadServiceId]) {
        try {
            const serviceObj = await Service.load(
                serviceRaw[firstLoadServiceId] || firstLoadServiceId,
            );
            if (serviceObj && serviceObj?.service?.service) {
                serviceList[firstLoadServiceId] = serviceObj;
                serviceSpecList[firstLoadServiceId] = new ServiceSpec(
                    serviceObj,
                );
                setService(serviceSpecList[firstLoadServiceId]);
            }
            // fetchingServiceList.value = false;
        } catch (e) {
            if (e.message === "Service load failed.") {
                pendServiceFetchError.value = true;
                return;
            }
        }
    } else if (firstLoadServiceId) {
        setService(serviceSpecList[firstLoadServiceId]);
        // fetchingServiceList.value = false;
    }

    // 2. 나머지는 병렬로 로드 (중복 제거 포함)
    const restToLoad = rest.filter((id) => !serviceList[id]);
    // let fetchedOnce = false;

    await Promise.all(
        restToLoad.map((serviceId) =>
            Service.load(serviceRaw[serviceId] || serviceId).then(
                (serviceObj) => {
                    if (serviceObj) {
                        serviceList[serviceId] = serviceObj;
                        serviceSpecList[serviceId] = new ServiceSpec(
                            serviceObj,
                        );

                        if (!initialLoadDone.value) {
                            initialLoadDone.value = true;
                        }

                        // if (!fetchedOnce) {
                        //     fetchedOnce = true;
                        // if (fetchingServiceList.value) {
                        //     fetchingServiceList.value = false; // ✅ 최소 1개 로드 성공
                        // }
                        // }
                    }
                },
            ),
        ),
    );

    allServicesLoaded.value = true;
};
